import { Actions, ActionTypes } from "./actions";
import { getInitialState, State } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.fetch:
      return {
        ...state,
        fetchStatus: "loading",
        error: undefined,
        fetchedAt: undefined
      };
    case ActionTypes.fetchSuccess:
      return {
        ...state,
        flights: action.payload.flightOffers,
        atolProtectedStatus: action.payload.atolProtectedStatus,
        cabinClassExtension: action.payload.cabinClassExtension,
        subsidizedFaresSummary: action.payload.subsidizedFaresSummary || [],
        availableFilters: action.payload.aggregation,
        baggagePolicies: action.payload.baggagePolicies,
        flightDeals: action.payload.flightDeals,
        fetchStatus: "success",
        error: undefined,
        campaignBanner: action.payload.campaignBanner,
        banners: action.payload.banners,
        searchCriteria: action.payload.searchCriteria,
        searchId: action.payload.searchId,
        displayOptions: action.payload.displayOptions,
        sortingOptions: action.payload.sortingOptions,
        remoteBanners: action.payload.remoteBanners,
        personalisationSegments: action.payload.personalisationSegments,
        flexPrice: action.payload.flexPrice, // flights_web_sr_new_flex_price_ml_model
        flexPriceWebVariant: action.payload.flexPriceWebVariant, // flights_web_sr_new_flex_price_ml_model
        fetchedAt: new Date().getTime()
      };

    case ActionTypes.fetchError:
      return {
        ...state,
        fetchStatus: "failed",
        error: action.payload,
        flights: [],
        availableFilters: {}
      };

    case ActionTypes.reset:
      return getInitialState();

    default:
      return state;
  }
};

export { reducer, getInitialState };
